<script>
export default {
  name: 'TwContainer'
}
</script>

<template>
  <div class="w-full mx-auto px-5 md:px-8 relative">
    <slot />
  </div>
</template>

<style scoped>

</style>
